export const WITHINGS_PREFILL_PROPERTY = 'prefilledFrom';

export const WITHINGS_PREFILL_SOURCE = 'withings';

// Added by core on the weight question while the current step still expects a weighing.
const WEIGHING_REMINDER_PREFIX = 'il vous reste au moins';

export const isWeighingReminder = (text: unknown): boolean =>
  typeof text === 'string' &&
  text.trim().toLowerCase().startsWith(WEIGHING_REMINDER_PREFIX);
